module.exports = __webpack_public_path__ + "img/tpc-printable-flyers-1.a78a54e0.webp";